module.exports = __webpack_public_path__ + "static/media/feedback.fff3f67e.svg";